import { TableCard } from '../../../../components'
import { EmpresasListHeader } from './component/header/EmpresasListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EmpresasTable } from './table/EmpresasTable'

const EmpresasList = () => {
  return (
    <TableCard>
      <EmpresasListHeader />
      <EmpresasTable />
    </TableCard>
  )
}

export const EmpresasListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <EmpresasList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
